import { Form, Input, Select, Space, Tooltip, Switch, Row, Col, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useState } from "react";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { staticConfig } from "../../../contractbooking.config";

const { Option } = Select;
const { Text, Link, Title, Paragraph } = Typography;

const MaturitySettings = ({ formData, allowRollover, form, updateFormData, customerAccOptions, onFinish, contractTemplate }) => {
  return (
    <div className="form-section">
      <h2 style={{ fontSize: "24px", margin: 0 }}>Maturity Settings</h2>
      <p style={{ marginTop: "5px", color: "#6b7280" }}>Add description text to note for users</p>

      <Form form={form} layout="vertical" onFinish={onFinish} style={{ width: "100%" }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please select target account",
                },
              ]}
              name="targetAccountId"
              label="Target Account"
            >
              <Select placeholder="Select target account" style={{ height: "44px" }} options={customerAccOptions} suffixIcon={<ChevronDown color="#667085" width={20} />} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Narration cannot be empty",
                },

                {
                  max: 50,
                  message: "Narration must be less than 50 characters",
                },
              ]}
              name="maturityNarration"
              label="Narration on Maturity"
            >
              <Input placeholder="Enter narration" style={{ height: "44px" }} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please select interest accrual",
                },
              ]}
              label={
                <Space>
                  Interest Accrual
                  <Tooltip title="Interest Accrual">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name="interestType"
            >
              <Select suffixIcon={<ChevronDown color="#667085" width={20} />} options={contractTemplate.interestTypeOptions} placeholder="Select interest accrual type" optionFilterProp="children" showSearch style={{ height: "44px" }} />
            </Form.Item>
          </Col>
        </Row>

        {/* <Row gutter={[16, 16]}> */}
        {/* <Col span={12}> */}
        {/* <Form.Item style={{ gap: 10 }} name={"allowRollover"} valuePropName="checked" colon={false}> */}
        {/* <div style={{ display: "flex", alignItems: "center", gap: 10 }}> */}
        {/* <Switch className="custom-switch" /> */}
        {/* <span style={{ marginLeft: 10 }}>Reinvestment Option</span> */}
        {/* </div> */}
        {/* {true && (
              <Col xs={24} sm={12}>
                <Form.Item name="ReinvestmentPlan">
                  <Select placeholder="Choose a reinvestment plan" style={{ height: "44px" }}>
                    <Option value="Manual">Manual</Option>
                    <Option value="Auto">Auto</Option>
                  </Select>
                </Form.Item>
              </Col>
            )} */}
        {/* </Form.Item> */}
        {/* </Col> */}

        <Row gutter={[16, 16]}>
          <Col
            span={6}
            style={{
              display: "flex",
              gap: 10,
              marginTop: 5,
              // alignItems: "center",
            }}
          >
            <Form.Item name={"allowRollover"} style={{ margin: 0, padding: 0 }} valuePropName="checked">
              <Switch className="custom-switch" />
            </Form.Item>
            {/* </Col> */}
            {/* <Col span={8} style={{ padding: "0px 8px" }}> */}
            <Text style={{ margin: 0, color: "#667085", marginTop: 5 }}>Re-investment option</Text>
          </Col>
          {allowRollover && (
            <Col span={6} style={{}}>
              <Form.Item
                style={{ margin: 0, padding: 0, width: "100%" }}
                name="autoRollover"
                rules={[
                  {
                    required: true,
                    message: "Please select rollover option",
                  },
                ]}
                // label={
                //   <Text style={{ color: "#344054" }}>
                //     Rollover Option <InfoCircleOutlined color="#667085" />
                //   </Text>
                // }
              >
                <Select
                  style={{
                    margin: 0,
                    padding: 0,
                    width: "100%",
                    height: "44px",
                  }}
                  className="custom-input"
                  // size="large"
                  options={staticConfig.rolloverOption}
                  placeholder={"Select rollover option"}
                  suffixIcon={<ChevronDown color="#667085" width={20} />}
                />
              </Form.Item>
            </Col>
          )}
        </Row>

        <Col
          span={12}
          style={{
            display: "flex",
            gap: 10,
            marginTop: 10,
            // alignItems: "center",
          }}
        >
          {" "}
          <Form.Item name={"autoMaturityTransfer"} style={{ margin: 0, padding: 0 }} valuePropName="checked">
            <Switch className="custom-switch" />
          </Form.Item>
          {/* </Col> */}
          {/* <Col span={8} style={{ padding: "0px 8px" }}> */}
          <Text style={{ margin: 0, color: "#667085", marginTop: 5 }}>Auto Maturity Transfer</Text>
        </Col>
        {/* <Col xs={24} sm={24} sty>
          <Form.Item name="AutoMaturityTransfer" valuePropName="checked">
            <Switch />
          </Form.Item>
          <span style={{ marginLeft: 10 }}> AutoMaturityTransfer</span>
        </Col> */}
        {/* </Row> */}
      </Form>
    </div>
  );
};

export default MaturitySettings;
